const billingES = {
	title: "Facturación y Suscripción",
	loading: "Cargando...",
	errorLoading: "No pudimos cargar los detalles de tu facturación en este momento. Inténtalo de nuevo.",

	currentSubscription: "Suscripción Actual",
	noSubscription: "No se encontró una suscripción.",
	startSubscription: "Comenzar suscripción",

	pricePerInterval: "{currency} {amount} / {interval}",
	nextBillingOn: "Próximo cobro: {date}",
	serviceEndsOn: "Tu suscripción termina el {date}",
	status: "Estado",
	billingInterval: "Cada {frequency} {interval}(s)",

	buttons: {
		updatePaymentMethod: "Actualizar método de pago",
		cancelSubscription: "Cancelar suscripción",
		manageSubscription: "Administrar suscripción",
	},

	scheduledCancel: {
		title: "Tu suscripción está programada para cancelarse",
		body: "Tu suscripción se cancelará el {date}. Hasta esa fecha todo sigue igual, pero después tu negocio dejará de aparecer en las búsquedas y no podrá recibir nuevas reservas. Puedes cancelar la cancelación cuando quieras antes de esa fecha.",
		bodyNoDate:
			"Tu suscripción está programada para cancelarse al final del periodo actual. Después, tu negocio dejará de aparecer en las búsquedas y no podrá recibir nuevas reservas.",
		keepButton: "Mantener mi suscripción",
		resumed: "¡Listo! Hemos anulado la cancelación y tu suscripción continúa con normalidad.",
	},

	suspension: {
		suspendedTitle: "Tu negocio está suspendido",
		suspendedBody:
			"No pudimos procesar el pago de tu suscripción, por lo que tu negocio no aparece en las búsquedas y no puede recibir nuevas reservas. Tus reservas actuales se mantienen. Reactívalo para volver a estar visible de inmediato.",
		warningTitle: "Hay un problema con tu pago",
		warningBody:
			"No pudimos procesar tu último pago. Tienes {days} día(s) para resolverlo antes de que tu negocio sea suspendido y deje de aparecer en las búsquedas.",
		reactivateButton: "Reactivar mi negocio",
		fixPaymentButton: "Resolver mi pago",
		working: "Un momento...",
		updateOpened: "Abrimos tu página de pago en una pestaña nueva. Tu negocio vuelve a estar activo en cuanto se procese el pago.",
		reactivated: "¡Listo! Tu negocio está activo de nuevo.",
		error: "No pudimos iniciar la reactivación. Inténtalo de nuevo o contacta con soporte si el problema continúa.",
	},

	paymentMethod: {
		title: "Método de Pago",
		noStored: "No hay método de pago guardado.",
		brand: "Marca",
		last4: "Últimos 4",
		expires: "Vence",
	},

	billingInfo: {
		title: "Información de Facturación",
		started: "Inició",
		firstBilled: "Primer cobro",
		nextBilling: "Próximo cobro",
		interval: "Intervalo",
	},

	upcomingPayment: {
		title: "Próximo Pago",
		date: "Fecha",
		subtotal: "Subtotal",
		discount: "Descuento por Referido",
		totalDue: "Total a Pagar",
	},

	transactions: {
		title: "Historial de Transacciones",
		date: "Fecha",
		invoice: "Factura",
		subtotal: "Subtotal",
		discount: "Descuento",
		total: "Total",
		status: "Estado",
		noInvoice: "—",
	},

	referralCredits: {
		title: "Créditos por Referidos",
		availableCredit: "crédito disponible",
		creditBalance: "Saldo de Crédito",
		rewardsEarned: "Recompensas obtenidas",
		referral: "referido",
		referrals: "referidos",
		usedCode: "Código Usado",
		code: "Código",
		status: "Estado",
		shopsReferred: "Negocios que Referiste",
		rewarded: "Recompensado",
		statusLabels: {
			pending_billing: "Esperando primer pago",
			pending_referrer_payment: "Esperando el primer pago del referidor",
			reward_issued: "Descuento aplicado ✓",
		},
	},

	discount: {
		active: "🎉 Descuento por referido activo",
		appliedRange: "Aplicado {from} → {to}",
	},

	plans: {
		title: "Planes Disponibles",
		options: "{count} opciones",
		choosePlan: "Elegir plan",
	},

	seatCap: {
		note: "{staff} miembros del equipo, {billed} facturados. Los asientos después de {max} son siempre gratis.",
	},

	seats: {
		activeSeats: "{count} asiento(s) activo(s)",
		seatPricing: "{currency} {amount} por asiento / mes",
		total: "Total facturado: {currency} {total}",
	},

	statusBadge: {
		active: "Activo",
		canceled: "Cancelado",
		paused: "Pausado",
		trialing: "En prueba",
		past_due: "Vencido",
		unpaid: "Sin pagar",
		incomplete: "Incompleto",
		incomplete_expired: "Expirado",
		completed: "Completado",
		paid: "Pagado",
		pending: "Pendiente",
		cancelScheduled: "Cancelación programada",
	},

	referral: {
		title: "Programa de Referidos",
		loading: "Cargando...",
		noCode: "Aún no tienes un código de referido.",
		generate: "Generar Código de Referido",
		codeLabel: "Tu Código:",
		copyCode: "Copiar Código",
		copyLink: "Copiar",
		copied: "Copiado al portapapeles",
		linkCopied: "¡Enlace copiado!",
		linkLabel: "Enlace de Referido",
		historyTitle: "Historial de Referidos",
		noReferrals: "Aún no tienes referidos.",
		defaultShopName: "Nuevo Negocio",
		applyTitle: "Código de Referido",
		applyPlaceholder: "Ingresa el código de referido",
		applyButton: "Aplicar",
		applyLoading: "...",
		usingCode: "Usando código:",
		applied: "¡Listo! Código de referido aplicado.",
		errorLoad: "No pudimos cargar tu información de referidos.",
		errorGenerate: "No pudimos generar tu código de referido. Inténtalo de nuevo.",
		errorApply: "No pudimos aplicar ese código de referido. Verifícalo e inténtalo de nuevo.",
		status: {
			pending: "Pendiente",
			active: "Activo",
			converted: "Convertido",
		},
	},
	misc: {
		month: "mes",
	},
};

export default billingES;
